import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['taxModeRadio', 'fullDiscountedTotalAmountCalculated']

  onPaymentRecurrenceClick(event) {
    this.displayfullDiscountedTotalAmount(event.currentTarget)
  }

  displayfullDiscountedTotalAmount(selectedRecurrenceTr) {
    const fullDiscountedTotalAmountCalculatedJson = JSON.parse(selectedRecurrenceTr.dataset.fullDiscountedTotalAmountCalculated)
    this.fullDiscountedTotalAmountCalculatedTarget.innerHTML = fullDiscountedTotalAmountCalculatedJson.formatted_html_amount
    $(this.fullDiscountedTotalAmountCalculatedTarget.querySelector('[data-popup="tooltip"]')).tooltip()

    const currentTaxMode = this.taxModeRadioTargets.find(radio => radio.checked)
    const changeEvent = new Event('change')
    currentTaxMode.dispatchEvent(changeEvent)
  }
}
